module.exports = __webpack_public_path__ + "img/banner1CN.e9a90770.png";